import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: '../../view/footer/footer.component.html',
    styleUrls: ['../../view/footer/footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  currentYear: any

  constructor() { 
    let d = new Date();
    this.currentYear = d.getFullYear();
  }

  ngOnInit() {

  }

}
